<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="feature.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <div class="form-group has-label">
      <label>Kategorie</label>
      <multiselect v-model="feature.custom_category"
        :options="customCategories"
        track-by="id"
        label="name"
      />
    </div>
    <div class="form-group has-label">
      <label>Feldtyp</label>
      <select class="custom-select" v-model="feature.type">
        <option value="dropdown">Dropdown</option>
        <option value="textinput">Freitextfeld</option>
        <option value="textarea">Textarea</option>
        <option value="number">Zahl</option>
        <option value="date">Datum</option>
        <!--
          <option value="checkbox">Checkbox</option>
          <option value="picture">Bild</option>
        -->
      </select>
    </div>
    <div class="form-group has-label" v-if="feature.type === 'dropdown'">
      <div class="form-group has-label">
        <l-checkbox v-model="feature.multiple">Mehrfachauswahl</l-checkbox>
      </div>
    </div>
    <div class="form-group has-label">
      <label>Status</label>
      <div>
        <l-radio v-model="feature.active" inline label="1">Aktiv</l-radio>
        <l-radio v-model="feature.active" inline label="0">Inaktiv</l-radio>
      </div>
    </div>
    <div class="form-group has-label">
      <l-checkbox v-model="feature.is_required">Pflichtfeld</l-checkbox>
    </div>
    <div class="form-group has-label">
      <l-checkbox v-model="feature.show">Anzeigen (Dropdowns, Listen, ...)</l-checkbox>
    </div>
    <div class="form-group has-label">
      <l-checkbox v-model="feature.product_default">Bei jedem neuen Produkt automatisch hinzufügen</l-checkbox>
    </div>
    <div class="form-group has-label">
      <l-checkbox v-model="feature.show_on_labels">Auf Etiketten anzeigen</l-checkbox>
    </div>
    <div class="form-group has-label">
      <l-checkbox v-model="feature.create_variations">Bei Produktneuanlage für alle Eigenschaften automatisch Variationen erstellen</l-checkbox>
    </div>
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
import { Radio as LRadio } from 'src/components'

export default {
  props: ['valErrors', 'initFeature', 'submitText'],
  components: { LRadio },
  data () {
    return {
      feature: this.initFeature,
      customCategories: []
    }
  },
  methods: {
    submit () {
      this.feature.custom_category_id = this.feature.custom_category ? this.feature.custom_category.id : null
      this.$emit('submit', this.feature)
    }
  },
  created () {
    this.$http.get(`/custom_categories`).then(({ data }) => {
      this.customCategories = data
    })
  }
}
</script>

<style scoped>
.form-check, .form-check-radio {
  margin-bottom: 0 !important;
}
</style>
